<div class="body_bg">
  <frontend-header></frontend-header>

  <section class="faq_header_section">
    <div class="container faq_banner">
      <div class="row">
        <div class="col-12">
          <div class="faq_hero">
            <h1>Frequently Asked Questions</h1>
            <p>Find answers to common questions about Kwot.</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="faq_content_section">
    <div class="container">

      <div class="row" *ngIf="isLoading">
        <div class="col-12 text-center">
          <p class="faq_status_msg">Loading...</p>
        </div>
      </div>

      <div class="row" *ngIf="!isLoading && (hasError || faqList.length === 0)">
        <div class="col-12 text-center">
          <p class="faq_status_msg">No FAQs available at the moment. Please check back later.</p>
        </div>
      </div>

      <div class="row" *ngIf="!isLoading && faqList.length > 0">
        <div class="col-lg-8 offset-lg-2">
          <div class="accordion faq_accordion" id="faqAccordion">
            <div class="accordion-item" *ngFor="let faq of faqList; let i = index">
              <h2 class="accordion-header" [id]="'faqHeading' + i">
                <button
                  class="accordion-button"
                  [ngClass]="{ collapsed: i !== 0 }"
                  type="button"
                  data-bs-toggle="collapse"
                  [attr.data-bs-target]="'#faqCollapse' + i"
                  [attr.aria-expanded]="i === 0"
                  [attr.aria-controls]="'faqCollapse' + i">
                  {{ faq.question }}
                </button>
              </h2>
              <div
                [id]="'faqCollapse' + i"
                class="accordion-collapse collapse"
                [ngClass]="{ show: i === 0 }"
                data-bs-parent="#faqAccordion">
                <div class="accordion-body">
                  <p>{{ faq.answer }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 text-center">
          <div class="buy_tokens_cta">
            <p>Ready to get started with Kwot?</p>
            <a routerLink="/purchase-token" class="buy_tokens_btn">Buy Tokens</a>
          </div>
        </div>
      </div>

    </div>
  </section>

  <frontend-footer></frontend-footer>
</div>
